import { render } from "./EnvanterTakip.vue?vue&type=template&id=8c9b64ee"
import script from "./EnvanterTakip.vue?vue&type=script&lang=js"
export * from "./EnvanterTakip.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__